import React from "react";
import { Box, Typography } from "@mui/material";
import { LEVEL_THRESHOLDS, UI_CONFIG } from "./constants";

/**
 * Color Legend Component
 * Displays a gradient legend showing project count levels from low to high
 */
export const ColorLegend: React.FC = () => (
  <Box
    sx={{
      width: "100%",
      backgroundColor: "white",
      padding: "16px 0",
      borderRadius: "12px",
      display: "flex",
      flexDirection: "column",
      gap: 1,
    }}
  >
    <Box sx={{ display: "flex", gap: 1 }}>
      {LEVEL_THRESHOLDS.map((level, index) => (
        <Box
          key={`${level.legendColor}-${index}`}
          sx={{
            flex: 1,
            height: UI_CONFIG.legendHeight,
            backgroundColor: level.legendColor,
            borderRadius: UI_CONFIG.borderRadius,
          }}
        />
      ))}
    </Box>

    <Box sx={{ display: "flex", justifyContent: "space-between", px: 0.5 }}>
      <Typography sx={{ fontWeight: 600 }}>Low</Typography>
      <Typography sx={{ fontWeight: 600 }}>High</Typography>
    </Box>
  </Box>
);
